import { BaseService } from '../../infra/base.service'
import type { Classification } from './classification'
import type { ClassificationsRepository } from './classifications.repository'

export class ClassificationsService extends BaseService<Classification> {
    constructor(private rep: ClassificationsRepository) {
        super(rep)
    }
}
